import React, { useCallback } from 'react';
import SchedinaAnalyzerTour from '../SchedinaAnalyzerTour';
import { DEMO_IMAGE } from './demoSelection';

const STEPS = [
  {
    targetId: 'my-selection-box',
    title: 'Nuova funzione: La mia selezione',
    body: (
      <>
        Carica lo screenshot della tua selezione: riconosciamo gli eventi in automatico. Per la demo usiamo questa selezione di esempio.
        <img src={DEMO_IMAGE} alt="Selezione di esempio" className="mt-2 w-full max-h-36 object-cover object-top rounded-lg border border-white/10" data-testid="my-selection-tour-demo-img" />
      </>
    ),
    placement: 'bottom',
  },
  {
    targetId: 'my-selection-row--3',
    title: 'Segui ogni evento live',
    body: 'Ogni evento si aggiorna in tempo reale: verde se è andato a segno, rosso se no, giallo se è in corso. In alto vedi il conteggio ✓ e ✗.',
    placement: 'bottom',
  },
  {
    targetId: 'my-selection-notify-toggle',
    title: 'Attiva gli avvisi',
    body: 'Tocca la campanella: ti mandiamo una notifica a ogni gol e quando un evento va a segno, più il riepilogo finale.',
    placement: 'bottom',
  },
  {
    targetId: 'search-toggle-btn',
    title: 'Partita non riconosciuta?',
    body: 'Cercala con la lente e tocca la stellina accanto alla partita per aggiungerla alla tua selezione.',
    placement: 'bottom',
  },
  {
    targetId: 'my-selection-share-btn',
    title: 'Condividi con gli amici',
    body: 'Crea l’immagine della tua selezione con gli esiti colorati e condividila su WhatsApp e social.',
    placement: 'top',
  },
  {
    targetId: null,
    title: 'Ora tocca a te!',
    body: 'Carica lo screenshot della tua selezione e seguila live.',
    placement: 'center',
  },
];

// Coach-mark tour over the demo selection; scrolls each target into view.
export const MySelectionTour = ({ onFinish }) => {
  const onStepChange = useCallback((i) => {
    const id = STEPS[i]?.targetId;
    if (!id) return;
    setTimeout(() => document.querySelector(`[data-testid="${id}"]`)?.scrollIntoView({ block: 'center', behavior: 'smooth' }), 50);
  }, []);
  return <SchedinaAnalyzerTour steps={STEPS} onFinish={onFinish} onStepChange={onStepChange} />;
};

export default MySelectionTour;
